/**
 * Authentication Utilities
 * 
 * Security: Uses httpOnly cookies for token storage (set by backend)
 * Frontend only tracks authentication state, never handles tokens directly
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Create axios instance with credentials enabled
export const authAxios = axios.create({
  baseURL: API,
  withCredentials: true, // Essential for httpOnly cookies
});

/**
 * Login admin user
 * Token is set via httpOnly cookie by backend - never exposed to JS
 */
export async function loginAdmin(username, password) {
  const response = await authAxios.post("/admin/login", { username, password });
  return response.data;
}

/**
 * Logout admin user
 * Clears the httpOnly cookie via backend
 */
export async function logoutAdmin() {
  try {
    await authAxios.post("/admin/logout");
  } catch (error) {
    // Log error but don't block logout flow - user intent is to leave
    console.warn("Logout request failed:", error.message || "Unknown error");
  }
}

/**
 * Check if user is authenticated
 * Validates session by calling a protected endpoint
 */
export async function checkAuth() {
  try {
    const response = await authAxios.get("/admin/me");
    return { authenticated: true, admin: response.data };
  } catch (error) {
    // Expected when not logged in - no need to log
    return { authenticated: false, admin: null };
  }
}

/**
 * Get auth headers for regular axios calls
 * Returns empty object since cookies are sent automatically
 */
export function getAuthHeaders() {
  return {}; // Cookies are automatically included with withCredentials
}

/**
 * Create axios config with credentials
 */
export function getAuthConfig() {
  return { withCredentials: true };
}
